import styled from 'styled-components';

import Box from 'elements/Box';
import animatedBanner from 'assets/hubworld-pulse.gif';

const ProfileHeader = styled(Box).attrs({
  height: 180,
  bg: 'darken',
  display: 'flex'
})`
  background-image: url(${animatedBanner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

export default ProfileHeader;
